import i18n from '@plugins/i18n';

import BaseValidator from './BaseValidator';
import RequiredValidator from './RequiredValidator';
import NationalInsuranceNumberValidator from './NationalInsuranceNumberValidator';
import TaxReferenceValidator from './TaxReferenceValidator';

export class NationalInsuranceOrTaxReferenceValidator extends BaseValidator {
    static key = 'nationalInsuranceOrTaxReference';

    static validator(ni = null, utrs = null) {
        const hasValidNI =
            RequiredValidator.validator(ni) === true && NationalInsuranceNumberValidator.validator(ni) === true;

        const hasValidUTR =
            Array.isArray(utrs) &&
            utrs.some(v => RequiredValidator.validator(v) === true && TaxReferenceValidator.validator(v) === true);

        if (hasValidNI || hasValidUTR) {
            return true;
        }

        if (!hasValidNI && !hasValidUTR) {
            return i18n.t('validator.national_insurance_number_or_tax_reference');
        }

        if (!hasValidNI) {
            return i18n.t('validator.national_insurance_number');
        }

        if (!hasValidUTR) {
            return i18n.t('validator.tax_reference_number');
        }

        return true;
    }

    static arguments() {
        return [];
    }
}

export default NationalInsuranceOrTaxReferenceValidator;
